import React from "react";
import { Tooltip } from "./Tooltip";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Footer = () => {
  return (
    <footer
      id="footer"
      className={
        "section  " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : "bg-dark footer-text-light ")
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-4 align-self-center text-center text-lg-start">
            <p className="mb-0">
              Акаунти шахрая Коломієць Іван у соціальних мережах
            </p>
          </div>
          <div className="col-lg-4 align-self-center justify-content-center justify-content-lg-start">
            <ul className="social-icons social-icons-lg social-icons-muted justify-content-center py-3 py-lg-0">
              <Tooltip text="Facebook" placement="top">
                <li className="social-icons-facebook">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://www.facebook.com/people/%D0%98%D0%B2%D0%B0%D0%BD-%D0%9A%D0%BE%D0%BB%D0%BE%D0%BC%D0%B8%D0%B5%D1%86/pfbid0gnMzTt4gtQJkxhi2FLLoHd3w4yGa2wijtgYhi5onuWf7djwTX98jjCYiJmangNuTl/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
              </Tooltip>
              <Tooltip text="Instagram" placement="top">
                <li className="social-icons-instagram">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://www.instagram.com/kolomiets3888/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </li>
              </Tooltip>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
